import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';

// Generiere anonyme Session-ID (ohne Cookies)
const getAnonymousId = (): string => {
  const storageKey = 'analytics_session_id';
  let sessionId = sessionStorage.getItem(storageKey);
  
  if (!sessionId) {
    // Erzeuge anonyme ID aus Timestamp + Random
    sessionId = `anon_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
    sessionStorage.setItem(storageKey, sessionId);
  }
  
  return sessionId;
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        await api.post('/analytics/track', {
          path: location.pathname,
          referer: document.referrer || null,
          userAgent: navigator.userAgent,
          anonymousId: getAnonymousId()
        });
      } catch (error) {
        // Silent fail - Analytics darf App nicht stören
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location]);
};
